"use client";

import { IProduct } from "@/types/product-d-t";
import { useState, useEffect } from "react";
import Loader from "../Loader";
import ProductItem from "./single-product/product-item";

type IProps = {
  trendingProd?: IProduct[];
};

export default function TrendingProducts({
  
  trendingProd = [],
}: IProps) {
  const [loading, setLoading] = useState(false);

  const [screen, setScreen] = useState({
    mobile: false,
    tablet: false,
    desktop: true,
  });

    const [visibleCount, setVisibleCount] = useState<number>(10);


  useEffect(() => {
    const resize = () => {
      const w = window.innerWidth;

      setScreen({
        mobile: w < 768,
        tablet: w >= 768 && w < 1024,
        desktop: w >= 1024,
      });
    };

    resize();
    window.addEventListener("resize", resize);

    return () => window.removeEventListener("resize", resize);
  }, []);

    const handleSeeMore = () => {
    const total = trendingProd.length || trendingProd.length;
    setVisibleCount(total);
  };

  return (
    <>
      {loading && <Loader />}

      <section
        style={{
          padding: screen.mobile ? "60px 12px" : "100px 40px",
          background: "#fff",
          maxWidth: "1500px",
          margin: "0 auto",
          marginTop:-60
        }}
      >
        {/* ---------- HEADER ---------- */}
        <div
          style={{
            textAlign: "center",
            marginBottom: screen.mobile ? "40px" : "70px",
            animation: "fadeIn .8s ease forwards",
          }}
        >
          <small
            style={{
              letterSpacing: "4px",
              color: "#aaa",
              fontWeight: 700,
              display: "block",
              marginBottom: 6,
            }}
          >
            TOP PICKS
          </small>

          <h2
            style={{
              fontSize: screen.mobile ? 30 : 52,
              fontWeight: 900,
              margin: "0 0 8px",
              color: "#111",
            }}
          >
            Must-Have Collections
          </h2>

          <p
            style={{
              maxWidth: 560,
              margin: "0 auto",
              fontSize: screen.mobile ? 13 : 15,
              color: "#777",
              lineHeight: 1.7,
            }}
          >
            Discover our handpicked trending styles crafted to elevate your everyday fashion.
          </p>
        </div>

        {/* ---------- PRODUCT GRID ---------- */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: screen.mobile
              ? "repeat(2,1fr)"
              : screen.tablet
              ? "repeat(3,1fr)"
              : "repeat(5,1fr)", // ✅ Desktop → 5 Cards
            gap: screen.mobile ? "12px" : "22px",
            animation: "fadeUp .8s ease forwards",
          }}
        >
          {trendingProd
            ?.slice(0, visibleCount)
            .map((item: any, index: number) => {
              const product = {
                ...item,
                image: item?.images?.[0]?.image || "/placeholder.png",
              };

              return (
                <ProductItem
                  key={index}
                  product={product}
                  setLoading={setLoading}
                />
              );
            })}
        </div>

        
        {/* See More Button */}
   {visibleCount < trendingProd.length && (
  <div className="row mt-35" style={{ display: "flex", justifyContent: "center" }}>
    <div
      className="col-12"
      style={{ display: "flex", justifyContent: "center" }}
    >
      <button
        onClick={handleSeeMore}
        className="cursor-pointer"
        style={{
          padding: "14px 42px",
          borderRadius: "999px",
          border: "none",
          background: "linear-gradient(135deg,#000,#444)",
          color: "#fff",
          fontWeight: "800",
          letterSpacing: "1px",
          textTransform: "uppercase",
          fontSize: "13px",
          transition: "all 0.3s ease",
          boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
          cursor: "pointer",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-3px)";
          e.currentTarget.style.boxShadow = "0 15px 40px rgba(0,0,0,0.35)";
          e.currentTarget.style.background = "linear-gradient(135deg,#111,#666)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.25)";
          e.currentTarget.style.background = "linear-gradient(135deg,#000,#444)";
        }}
      >
        Explore More Products →
      </button>
    </div>
  </div>
)}

      </section>

      {/* ---------- ANIMATIONS ---------- */}
      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-12px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </>
  );
}
